<template>
    <div class="giftcard-section">
        <div class="giftcard-content">
            <h2 class="giftcard-title fuente-posm">
                Integra tus Propias Gift<br>
                <span>Card digitales</span>
            </h2>
            <p class="giftcard-text fuente-nova">
                Con Efisense Rewards puedes ofrecer tarjetas de regalo personalizadas que fortalecen tu marca, impulsan tus ventas y aumentan la recompra.
                <br><br>
                Los tickets donde se usa una Gift Card son, en promedio, un 20% más altos que el resto.
            </p>
        </div>
        <div class="giftcard-image">
            <img :src="a24" alt="Gift Cards">
        </div>
    </div>
</template>

<script>
export default {
    name: 'GiftCardRewardNew',
    data() {
        return {
            a24: require('@/assets/images/a24.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.giftcard-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
    background-color: #272727;
}

.giftcard-content {
    flex: 1;
    max-width: 600px;
    order: 1;
}

.giftcard-title {
    color: var(--color-5);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.giftcard-text {
    color: var(--color-5);
    font-size: 27px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

.giftcard-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.giftcard-image img {
    width: 100%;
    max-width: 500px;
    height: auto;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .giftcard-title {
        font-size: 60px;
    }

    .giftcard-text {
        font-size: 25px;
    }

    .giftcard-image img {
        max-width: 400px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .giftcard-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .giftcard-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .giftcard-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .giftcard-image img {
        width: 90%;
        max-width: 350px;
    }

    .giftcard-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .giftcard-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
